import React from 'react'
import { Grid, Button, Paper, Table, TableHead, TableCell, TableBody } from '@material-ui/core'
import { connect } from 'react-redux'
import {
  GET_COMPONENT_TYPES,
  UPDATE_COMPONENT_TYPE,
  ADD_COMPONENT_TYPE,
  DELETE_COMPONENT_TYPE,
} from './GraphQL'
import { useLazyQuery, useMutation } from '@apollo/react-hooks'
import { startLoading, stopLoading } from '../../../actions/loading'
import { hasAccess } from '../../../utils/api'
import { formatErrors } from '../../../utils/common'

import ComponentTypeListItem from './ComponentTypeListItem'
import EditableHOCWrapper from '../../../containers/HOC/EditableHOC'

import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import AddComponentTypeModal from '../../../components/Modal/AddComponentTypeModal'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ModalDialog from '../../../components/common/ModalDialog'

const ComponentTypeListItemEditable = EditableHOCWrapper(ComponentTypeListItem)

let columns = ['Name', 'Status', '']

const ComponentTypes = (props) => {
  const permitted = hasAccess()
  const addComponentTypeModal = React.useRef(null)
  const deleteModal = React.useRef(null)
  const [componentTypeList, setComponentTypeList] = React.useState([])
  const [isUpdateCompleted, setIsUpdateCompleted] = React.useState(false)
  const [selectedItemToDelete, setSelectedItemToDelete] = React.useState({})

  // eslint-disable-next-line no-unused-vars
  const [componentTypes, resComponentTypes] = useLazyQuery(GET_COMPONENT_TYPES, {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({ componentTypes }) => {
      setComponentTypeList(componentTypes)
      props.dispatch(stopLoading())
    },
    onError: (error) => {
      //props.handleError(formatErrors(error), 'error');
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })
  // eslint-disable-next-line no-unused-vars
  const [addComponentType, resAddComponentType] = useMutation(ADD_COMPONENT_TYPE, {
    //refetchQueries: ["getComponentTypes"],
    onCompleted: (data) => {
      props.dispatch(stopLoading())
      //Appcues.track("Component type Info saved");
      addComponentTypeModal.current.handleClose()
      onSuccess('New component type saved')
      fetchApi()
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })
  // eslint-disable-next-line no-unused-vars
  const [updateComponentType, resUpdateComponentType] = useMutation(UPDATE_COMPONENT_TYPE, {
    onCompleted: (data) => {
      setIsUpdateCompleted(true)
      props.dispatch(stopLoading())
      //Appcues.track("Component type Info saved");
      onSuccess('Component type Info saved')
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  // eslint-disable-next-line no-unused-vars
  const [deleteComponentType, resDeleteComponentType] = useMutation(DELETE_COMPONENT_TYPE, {
    //refetchQueries: ["getComponentTypes"],
    onCompleted: (data) => {
      props.dispatch(stopLoading())
      deleteModal.current.handleClose()
      //Appcues.track("Component type Info saved");
      onSuccess('Component type deleted')
      fetchApi()
    },
    onError: (error) => {
      onError(formatErrors(error))
      props.dispatch(stopLoading())
    },
  })

  React.useEffect(() => {
    fetchApi()
  }, [])

  const fetchApi = () => {
    props.dispatch(startLoading())
    setComponentTypeList([])
    componentTypes({
      variables: {},
    })
  }

  const onError = (message) => props.dispatch(openErrorMessage(message))
  const onSuccess = (message) => props.dispatch(openSuccessMessage(message))

  const validateComponentType = (componentType) => {
    if (!componentType.name) {
      onError('Please enter component type name')
      return false
    }
    return true
  }

  const onSave = (data, afterOnSave) => {
    if (validateComponentType(data)) {
      setIsUpdateCompleted(false)
      const input = { id: data.id, name: data.name, active: data.active }
      props.dispatch(startLoading())
      updateComponentType({ variables: { input } })
    }
  }

  const addComponentTypeApiCall = (data) => {
    props.dispatch(startLoading())
    addComponentType({ variables: { input: data } })
  }

  const openDeleteModal = (item) => (e) => {
    setSelectedItemToDelete(item)
    deleteModal.current.handleClickOpen()
  }

  const onDeleteItem = (e) => {
    props.dispatch(startLoading())
    deleteComponentType({ variables: { id: selectedItemToDelete.id } })
  }

  return (
    <div>
      <Grid container>
        <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
          {permitted ? (
            <Button
              variant="raised"
              className="primary-button pull-right margin-bottom-small"
              onClick={() => addComponentTypeModal.current.handleClickOpen()}
            >
              Add Component Type
            </Button>
          ) : null}
        </Grid>
      </Grid>
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper>
            <div className="table-scroll">
              <Table>
                <TableHead>
                  {columns && columns.map((col) => <TableCell>{col}</TableCell>)}
                </TableHead>
                <TableBody>
                  {componentTypeList &&
                    componentTypeList.length > 0 &&
                    componentTypeList.map((data, index) => (
                      <ComponentTypeListItemEditable
                        key={index}
                        dataToEdit={data}
                        onSave={onSave}
                        isUpdateCompleted={isUpdateCompleted}
                        onDelete={openDeleteModal(data)}
                      />
                    ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
      <AddComponentTypeModal
        ref={addComponentTypeModal}
        addComponentType={addComponentTypeApiCall}
        onError={onError}
      />
      <ModalDialog ref={deleteModal} onConfirm={onDeleteItem} confirmText="delete">
        Are you sure you want to delete '{selectedItemToDelete.name}'
      </ModalDialog>
    </div>
  )
}

export default connect(({ dispatch, shopReducer }) => ({
  dispatch,
  shopReducer,
}))(ContainerWithTitle(ComponentTypes, 'Component Types'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/ComponentTypes.js